import { defineMessages } from 'react-intl';

export default defineMessages({
  'timeAxisLabel': {
    id: 'explorerPage.timeAxisLabel',
    defaultMessage: 'Time'
  }
});